// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rp7oEJiiSfixcyPnJqmt {
    justify-content: center;
    align-items: center;
    display: flex;
    gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Telehealth/MeetingStatusInfo/MeetingStatusInfo.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,QAAQ;AACZ","sourcesContent":[".container {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `rp7oEJiiSfixcyPnJqmt`
};
export default ___CSS_LOADER_EXPORT___;
